import { AdvancedFilterConfig, FILTER_OPERATORS } from '../../types/filter';
import { InnerButton } from '@/modules/InnerButton';
import { cn } from '@/shared/utils/cn';
import { Icon } from '@/modules/Icon';
import { faFilter, faTrash } from '@fortawesome/pro-regular-svg-icons';
interface FilterListProps {
  filters: AdvancedFilterConfig[];
  onRemoveFilter: (filterId: string) => void;
  className?: string;
}

export const FilterList = ({ filters, onRemoveFilter, className }: FilterListProps) => {
  if (filters.length === 0) {
    return (
      <div
        className={cn(
          'ui-flex ui-flex-col ui-items-center ui-justify-center ui-gap-2 ui-px-4 ui-py-8',
          className,
        )}
      >
        <div className="ui-flex ui-size-16 ui-items-center ui-justify-center ui-rounded-control-pill ui-bg-blue-100">
          <Icon name={faFilter} size="lg" color="blue" />
        </div>
        <p className="ui-text-base ui-font-semibold ui-text-primary">No hay Filtros configurados</p>
        <p className="ui-max-w-[280px] ui-text-center ui-text-body-xs-regular ui-text-neutral-500">
          Agrega un filtro seleccionando una columna
        </p>
      </div>
    );
  }

  const getOperatorLabel = (operator: string) => {
    const op = FILTER_OPERATORS.find((o) => o.value === operator);
    return op?.label || operator;
  };

  const getFilterLabel = (filter: AdvancedFilterConfig) => {
    const operatorLabel = getOperatorLabel(filter.operator);
    const operatorConfig = FILTER_OPERATORS.find((o) => o.value === filter.operator);

    if (!operatorConfig?.requiresValue) {
      return `${filter.columnLabel} ${operatorLabel.toLowerCase()}`;
    }

    if (operatorConfig.requiresSecondValue && filter.value2) {
      return `${filter.columnLabel} ${operatorLabel.toLowerCase()} ${filter.value} y ${filter.value2}`;
    }

    return `${filter.columnLabel} ${operatorLabel.toLowerCase()} "${filter.value}"`;
  };

  return (
    <div className={cn('ui-flex ui-flex-col ui-gap-2', className)}>
      <p className="ui-px-1 ui-text-sm ui-font-semibold ui-text-primary">
        Filtros activos ({filters.length})
      </p>
      <div className="custom-scrollbar ui-flex ui-max-h-[200px] ui-flex-col ui-gap-1 ui-overflow-y-auto">
        {filters.map((filter) => (
          <div
            key={filter.id}
            className="ui-flex ui-items-center ui-justify-between ui-gap-2 ui-rounded-sm ui-border ui-border-default ui-bg-fill ui-px-3 ui-py-2 ui-transition-colors hover:ui-bg-surface-disabled"
          >
            <div className="ui-flex ui-min-w-0 ui-flex-1 ui-flex-col ui-gap-0.5">
              <p className="ui-truncate ui-text-body-xs-regular ui-font-medium ui-text-primary">
                {getFilterLabel(filter)}
              </p>
            </div>
            <InnerButton
              theme="solid"
              color="secondary"
              size="xxs"
              iconProps={{ icon: faTrash }}
              onClick={() => onRemoveFilter(filter.id)}
              tooltipProps={{ label: 'Eliminar filtro', position: 'left' }}
              pill="sm"
            />
          </div>
        ))}
      </div>
    </div>
  );
};
